





























import { Vue, Component, Prop } from "vue-property-decorator";

// Types
import { IClient } from "@/models/clients";

@Component({
  components: {
    "billable-entities-provider": () =>
      import("@/components/app/global/client/billableEntitiesProvider.vue"),
    "billable-entities": () =>
      import("@/components/app/global/client/billableEntities.vue"),
    "billable-entities-control": () =>
      import("@/components/app/global/client/billableEntitiesControl.vue")
  }
})
export default class BillableEntitiesComp extends Vue {
  // Props

  @Prop({ required: true })
  public clientId!: IClient["id"];

  @Prop({ default: false })
  public isStaged!: boolean;

  @Prop({
    required: true,
    validator: tag =>
      ["u-aside", "u-section-box", "u-contextualise"].includes(tag)
  })
  public readonly tag!: string;
}
